export const ISOLATE_BOUNDARY_MAXIMUM_NUMBER_OF_POLYGONS = 150;
export const BOUNDARY_OUTLINE_MAXIMUM_NUMBER_OF_POLYGONS = 180;
